import type { AirportBusProviderConfig } from "../config/types";

/**
 * Lufthansa Express Bus provider config.
 * Passenger types: Adult (PNOS) 15–64, Child (PCIL) 6–14, Infant (PINT) 0–5.
 * Branding and the route offer code come from the provider info API at runtime.
 */
export const lufthansaExpressBusConfig: AirportBusProviderConfig = {
  slug: "lufthansa-express-bus",
  fallbackDisplayName: "Lufthansa Express Bus",
  passengerTypes: [
    {
      code: "PNOS",
      labelKey: "transport.lufthansaExpressBusPassengerTypeAdult"
    },
    {
      code: "PCIL",
      labelKey: "transport.lufthansaExpressBusPassengerTypeChild"
    },
    {
      code: "PINT",
      labelKey: "transport.lufthansaExpressBusPassengerTypeInfant"
    }
  ],
  defaultPassengerTypeCode: "PNOS",
  estimationTimeStrategy: "current-local-time",
  i18n: {
    validity: "transport.lufthansaExpressBusValidity",
    nonRefundable: "transport.lufthansaExpressBusNonRefundable"
  }
};
